import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { FeedFilter } from 'api/KnowledgeAPI';

type TrackerFilters = {
  searchKeyword: string;
  filters: FeedFilter[];
};

type TrackerStoreState = {
  trackerState: Record<
    string, // companyId
    Record<
      string, // trackerId
      TrackerFilters
    >
  >;
  setTrackerState: (companyId: string, trackerId: string, state: Partial<TrackerFilters>) => void;
  resetTrackerState: (companyId: string, trackerId?: string) => void;
};

const useTrackerStore = create<TrackerStoreState>()(
  persist(
    (set) => ({
      trackerState: {},
      setTrackerState: (companyId, trackerId, state) =>
        set((prev) => {
          const companyTrackers = prev.trackerState[companyId] || {};
          const prevTracker = companyTrackers[trackerId] || { searchKeyword: '', filters: [] };
          return {
            trackerState: {
              ...prev.trackerState,
              [companyId]: {
                ...companyTrackers,
                [trackerId]: {
                  ...prevTracker,
                  ...state,
                },
              },
            },
          };
        }),
      resetTrackerState: (companyId, trackerId) =>
        set((prev) => {
          if (!companyId) return { trackerState: {} };
          if (trackerId) {
            const { [trackerId]: _, ...restTrackers } = prev.trackerState[companyId] || {};
            return {
              trackerState: {
                ...prev.trackerState,
                [companyId]: restTrackers,
              },
            };
          }
          const { [companyId]: _, ...restCompanies } = prev.trackerState;
          return { trackerState: restCompanies };
        }),
    }),
    {
      name: 'tracker-store',
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({ trackerState: state.trackerState }),
    },
  ),
);

export default useTrackerStore;
